export default {
  SET_DECLARACAO_IMPORTACAO_TABLE_ITEMS(state, payload) {
    state.declaracaoImportacaoTableItems = payload;
  },
  SET_FILTROS(state, payload) {
    state.filtros = payload;
  },
  SET_ITEM_BY_CODIGO_DECLARACAO_IMPORTACAO(state, payload) {
    state.itemsDeclaracaoImportacaoByCodigoDI = payload;
  },
};
